import React, { Component } from 'react';
import NavBar from '../../../../_components/common/Navbar';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { relationGroupstables } from '../relationGrouptableColumns';
import Aux from '../../../../_components/common/Hoc'
import SettingsHead from '../../../../_components/common/SettingsHead';
import { connect } from 'react-redux';
import Settings from '../../../../_components/common/SettingsHeader';
import { addRelationGroups, addRelation } from '../relationGroupsFormData';
import ModalNew from '../../../../_components/common/ModalNew';
import { editRelationGroup, editRelationAction, deleteRelationGroup, relationGroupsTableActions, getRelationList } from '../../../../_actions';
import SweetAlert from '../../../../../node_modules/sweetalert2-react/lib/SweetAlert';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';


import Page404 from '../../../404page';


class RelationGroupDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            editRelationGroupState: false,
            editRelationState: false,
            deleteRelationGroupState: false,
            RelationGroupModal: false,
            editRelationGroupData: '',
            editRelationData: '',
            relationId: this.props.location.state ? this.props.location.state.columnData.id : 0,
            addRelation: []
        }
    }

    componentDidMount() {
        // this.props.dispatch(relationGroupsTableActions.getRelationGroups());
        this.props.dispatch(getRelationList.getRelationListHandler())
        // this.resetFormData();
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal
        });
    }

    toggleRelationGroupModal(showModal) {
      
        this.setState({
            deleteRelationGroupState: false,
            editRelationGroupState: showModal
        })
    }

    getValueForRelation(relation) {
      
        for (let i in this.props.relationGroupsResponse) {
            if (this.props.relationGroupsResponse[i].id === this.state.relationId) {
                for (let j in this.props.relationGroupsResponse[i].relation_list) {

                    if (this.props.relationGroupsResponse[i].relation_list[j].accessor_group__assessor_name === relation.assessor_name) {
                        return true
                    }
                }
            }
        }
        return false
    }

    toggleRelationModal(showModal) {

        let addRelation = []
        this.props.relationListResponse.map(
            (relation, i) => {
                addRelation.push(
                    {
                        key: relation.assessor_name,
                        type: 'checkbox',
                        value: this.getValueForRelation(relation),
                        valid: true,
                        elementConfig: {
                            name: relation.assessor_name,
                            label: relation.assessor_name,
                        },
                        validation: {
                            required: false,
                            message: ""
                        }
                    }
                )
            }
        )
      
        this.setState({
            deleteRelationGroupState: false,
            editRelationState: showModal,
            addRelation: addRelation
        })
    }

    toggleDeleteRelationModal(showModal) {
    
        this.setState({
            deleteRelationGroupState: showModal
        })
    }

    toggleEditRelationGroupResponse(data) {
     
        this.setState({
            editRelationGroupData: data
        })
    }

    toggleEditRelationResponse(data) {
        this.setState({
            editRelationData: data
        })
    }



    editRelationGroupAction(data) {
     
        const fd = {
            'relation_group_name': data.sellerData.relation_group_name,
            'style_introduction_line': data.sellerData.style_introduction_line,
            'min_respondent': data.sellerData.min_respondent,
            'default_enabled': data.sellerData.default_enabled
        }

     
        const id = this.props.location.state.columnData.id;
        this.props.dispatch(editRelationGroup.addData(id, fd))
    }

    editRelationAction(data) {
  
        let contId = [];

        for (let i in data.sellerData.relation_list) {
            for (let j in this.props.relationListResponse) {
                if (this.props.relationListResponse[j].assessor_name === data.sellerData.relation_list[i]) {
                    contId.push(this.props.relationListResponse[j].id)
                }
            }
        }
        // const id = this.state.developmentPlanId;

        const fd = {
            'relation_list': contId
        }
   
        const id = this.props.location.state.columnData.id;
        this.props.dispatch(editRelationAction.editRelation(id, fd))
    }

 

    toggleEntireEditRelationGroup(showModal) {
        this.setState({
            editRelationGroupState: showModal
        })
    }

    toggleEntireRelationModal(showModal) {
        this.setState({
            editRelationState: showModal
        })
    }

    getRelationData() {
        for (let i in this.props.relationGroupsResponse) {
            if (this.props.relationGroupsResponse[i].id === this.state.relationId) {
                return this.props.relationGroupsResponse[i]
            }
        }
    }

    render() {
        if(this.props.location.state) {
            const { columnData } = this.props.location.state;

            const { relationGroupsResponse } = this.props;
    
            const relationGroupData = relationGroupsResponse === '' ? columnData : this.getRelationData();
    
    
            const relationData = relationGroupsResponse === '' ? columnData : this.getRelationData();
    
          
            addRelationGroups.map(
                (data, i) => {
                    if(data.key === 'relation_group_name') {
                        if(columnData.is_default === true) {
                            data.type = 'plaintext'
                        }else {
                            data.type = 'text'
                        }
                    }
                    data.value = relationGroupData[data.key];
                    data.valid = true;
                })
    
    
            let buttonDataProp = []
          
            columnData.is_default === true ?
                buttonDataProp.push({
                    id: 1,
                    heading: "EDIT RELATION GROUP",
          
                    toggler: this.toggleRelationGroupModal.bind(this),
                    togglerModal: this.state.editRelationGroupState
                },
                    {
                        id: 2,
                        heading: "EDIT RELATIONS",
                        toggler: this.toggleRelationModal.bind(this),
                        togglerModal: this.state.editRelationState
    
                    })
                :
                buttonDataProp.push({
                    id: 1,
                    heading: "EDIT RELATION GROUP",
       
                    toggler: this.toggleRelationGroupModal.bind(this),
                    togglerModal: this.state.editRelationGroupState
                },
                    {
                        id: 2,
                        heading: "EDIT RELATIONS",
                        toggler: this.toggleRelationModal.bind(this),
                        togglerModal: this.state.editRelationState
    
                    },
                    {
                        id: 3,
                        heading: "DELETE RELATION GROUP",
                        toggler: this.toggleDeleteRelationModal.bind(this),
                        togglerModal: this.state.deleteRelationGroupState
                    })
    
    
            return (
                <div>
                    <NavBar />
    
                    <div className="container custom-container my-5" >
    
                        <div>
                            <CommonBreadCrumb
                                data={[
                                    {
                                        link: '/admin/app/dashboard',
                                        name: 'ADMIN'
                                    }, {
                                        link: '/admin/app/relation-groups',
                                        name: 'RELATION GROUPS'
                                    }, {
                                        link: '',
                                        name: 'RELATION GROUP DETAILS'
                                    }
                                ]}
                            />
    
                        </div>
    
                        <div className="bg-green rounded-top animation-fade-in">
                            <h6 className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> {relationGroupData.relation_group_name} </h6>
                            <div>
                                <Settings
                                    buttonData={buttonDataProp}
                                    filter={false}
                                    // secondColumn={false}
                                    modal={this.toggleModal.bind(this)}
                                    showModal={this.state.modal}
                                />
                            </div>
    
                            <div className="d-flex flex-row flex-wrap light-grey">
                                {
                                    relationGroupstables.relationGroups.map(
                                        (relationGroup, i) => {
                                            return (
                                                <Aux key={i}>
                                                    {
                                                        i === 1 &&
                                                        <Aux>
                                                            <div className="py-4 col-3">
                                                                <strong className="text-uppercase bold">
                                                                    Style Introduction (for report) </strong>
                                                            </div>
                                                            <div className="col-9 py-4 text-center text-md-left">
                                                                <span>
                                                                    {relationGroupData.style_introduction_line}
                                                                </span>
                                                            </div>
                                                        </Aux>
                                                    }
                                                    <div className="py-4 col-3">
                                                        <strong className="text-uppercase bold"> {relationGroup.name} </strong>
                                                    </div>
                                                    <div className="col-9 py-4 text-center text-md-left">
                                                        <span>
                                                            {
                                                                relationGroup.key === 'default_enabled' &&
                                                                relationGroupData.default_enabled === true &&
                                                                "Yes"
                                                            }
    
                                                            {
                                                                relationGroup.key === 'default_enabled' &&
                                                                relationGroupData.default_enabled === false &&
                                                                "No"
                                                            }
    
                                                            {
                                                                relationGroup.key === 'relation_list' &&
                                                                relationData[relationGroup.key].map(
                                                                    (data, i) => {
                                                                        if (relationData[relationGroup.key].length === i + 1) {
                                                                            return data.accessor_group__assessor_name
                                                                        }
                                                                        else {
                                                                            return data.accessor_group__assessor_name + ', '
                                                                        }
    
                                                                    }
                                                                )
                                                            }
    
                                                            {
                                                                relationGroup.key !== 'relation_list' &&
                                                                relationGroupData[relationGroup.key]
                                                            }
    
    
                                                            {/* RelationGroupData[relationGroup.key] === true || false? RelationGroupData[relationGroup.key] === true? Yes: No : RelationGroupData[relationGroup.key] */}
                                                        </span>
                                                    </div>
                                                </Aux>
                                            )
    
                                        }
                                    )
    
                                }
    
                                {
                                    this.state.editRelationGroupState &&
                                    <ModalNew
                                        modalName="EDIT RELATION GROUP"
                                        heading="EDIT RELATION GROUP"
                                        showModal={this.state.editRelationGroupState}
                                        formData={addRelationGroups}
                                        action={this.editRelationGroupAction.bind(this)}
                                        toggleEditResponse={this.toggleEditRelationGroupResponse.bind(this)}
                                        toggleEntireModal={this.toggleEntireEditRelationGroup.bind(this)}
    
                                    />
                                }
    
                                {
                                    this.state.editRelationState &&
                                    <ModalNew
                                        modalName="inlineCheckbox2"
                                        heading="EDIT RELATIONS"
                                        showModal={this.state.editRelationState}
                                        formData={this.state.addRelation}
                                        action={this.editRelationAction.bind(this)}
                                        toggleEditResponse={this.toggleEditRelationResponse.bind(this)}
                                        toggleEntireModal={this.toggleEntireRelationModal.bind(this)}
                                        checkBoxData={addRelationGroups}
                                    />
                                }
   

                                {
                                    this.state.deleteRelationGroupState &&
                                    <SweetAlert
                                        show={this.state.deleteRelationGroupState}
                                        title=''
                                        text={`Are you sure you want to delete ${relationGroupData.relation_group_name}?`}
                                        type="warning"
                                        showCancelButton={true}
                                        confirmButtonColor="#3085d6"
                                        cancelButtonColor='#d33'
                                        confirmButtonText='Yes, delete it!'
                                        onConfirm={() => {
                                            this.props.dispatch(deleteRelationGroup.deleteRelation(relationGroupData.id))
                                            this.props.history.replace('/admin/app/relation-groups');
                                            this.setState({ deleteRelationGroupState: false })
                                            // window.location.reload();
                                        }
                                        }
                                    />
                                }
    
    
                                {/* <div className="py-4 col-3">
                                    <strong className="text-uppercase bold"> Relation Group </strong>
                                </div>
                                <div className="col-9 py-4">
                                    <span className="text-capitalize">{columnData.relation_group_name}</span>
                                </div>
    
                                <div className="py-4 col-3">
                                    <strong className="text-uppercase bold"> Style Introduction (for report) </strong>
                                </div>
                                <div className="col-9 py-4">
                                    <span className="text-capitalize">{columnData.style_introduction_line}</span>
                                </div>
    
                                <div className="py-4 col-3">
                                    <strong className="text-uppercase bold"> Min. Respondents </strong>
                                </div>
                                <div className="col-9 py-4">
                                    <span className="text-capitalize">{columnData.style_introduction_line}</span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div >
            )
        }else {
            return (
                <div>
                    <NavBar />
                    <Page404 />
                </div>
            )
        }
        
    };
}

function mapStateToProps(state) {
   

    const { relationGroupsLoading, error } = state.relationGroupTable;
    const relationGroupsResponse = (!relationGroupsLoading && !error) ? state.relationGroupTable.data.data.results : '';

    const { RelationListLoading } = state.relationList;
    const relationListResponse = (!RelationListLoading) ? state.relationList.data.data.results : '';
    const relationListResponseCode = (!RelationListLoading) ? state.relationList.data.status : '';

    return {
        relationGroupsLoading,
        relationGroupsResponse,

        relationListResponse,
        relationListResponseCode,
    };
}

export default connect(mapStateToProps)(RelationGroupDetails);


// WEBPACK FOOTER //
// ./src/_pages/Admin/RelationGroups/Details/index.jsx